import { useCallback, useState } from 'react'
import { resolveMissStatus } from './claimedStatus'

// Explains a null from the public API: was the layout claimed into a workspace? `claimed`
// swaps the planner's generic unavailable copy for the CLAIMED panel/banner. A failed
// status call counts as unavailable (resolveMissStatus never rejects).
export default function useClaimedMiss () {
  const [claimed, setClaimed] = useState(false)

  // Load path. Resolves true when the caller is still current and should go on to render
  // the unavailable state; false when it went stale during the lookup (nothing recorded).
  const explainLoadMiss = useCallback(async (layoutUuid, isCurrent) => {
    const status = await resolveMissStatus(layoutUuid)
    if (!isCurrent()) return false
    setClaimed(status === 'claimed')
    return true
  }, [])

  // Read-only path, called after the page has already stopped saving.
  const explainReadOnlyMiss = useCallback(async (layoutUuid, isCurrent) => {
    const status = await resolveMissStatus(layoutUuid)
    if (isCurrent() && status === 'claimed') setClaimed(true)
  }, [])

  const resetClaimed = useCallback(() => setClaimed(false), [])

  return { claimed, explainLoadMiss, explainReadOnlyMiss, resetClaimed }
}
